import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Alert from "@mui/material/Alert";

export default function YesNoDialog(props) {
  React.useState(false);
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      style={{ zIndex: "99999" }}
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Alert variant="outlined" severity="warning">
            {props.content}
          </Alert>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          {props.noBtnName === "" ? "No" : props.noBtnName}
        </Button>
        <Button onClick={props.handleYes} color="primary" autoFocus>
          {props.yesBtnName === "" ? "Yes" : props.yesBtnName}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
